import apiHandler from "../core/apiHandler";

const saleDashboardApi = apiHandler('dashboard/sales');
export default saleDashboardApi;
